import { _t } from "core/language";
import React, { memo, useEffect, useState } from "react";
import { useSuggestionByType } from "../hooks";
import { TypeSuggestion } from "../type";
import EnrichmentCard from "./EnrichmentCard";
import SectionSkeleton from "./SectionSkeleton";
import MainNodata from "./NodataComponent";
// import Taste1 from "../assets/images/taste_1.svg";
// import Taste2 from "../assets/images/taste_2.svg";
// import Taste3 from "../assets/images/taste_3.svg";
// import Taste4 from "../assets/images/taste_4.svg";
// import Taste5 from "../assets/images/taste_5.svg";


// import IconTitle from "../assets/images/icon_section_enrichment.svg";
import IconSectionEnrichment from "./icon/IconSectionEnrichment";
import Taste1 from "./icon/enrichment/Taste1";
import Taste2 from "./icon/enrichment/Taste2";
import Taste3 from "./icon/enrichment/Taste3";
import Taste4 from "./icon/enrichment/Taste4";
import Taste5 from "./icon/enrichment/Taste5";


// const backgroundColors = [
//   "bg-[#EC2F58]",
//   "bg-[#3CAF5B]",
//   "bg-[#F67C47]",
//   "bg-[#94593F]",
//   "bg-[#4C7D7D]",
// ];

const ImageTaste = [
  {
    title: "main.tasteTitle1",
    description: "main.tasteDescription1",
    thumbnail: <Taste1 />,  
  },
  {
    title: "main.tasteTitle2",
    description: "main.tasteDescription2",
    thumbnail: <Taste2 />,  
  },
  {
    title: "main.tasteTitle3",
    description: "main.tasteDescription3",
    thumbnail: <Taste3 />,  
  },
  {
    title: "main.tasteTitle4",
    description: "main.tasteDescription4",
    thumbnail: <Taste4 />,  
  },
  {
    title: "main.tasteTitle5",
    description: "main.tasteDescription5",
    thumbnail: <Taste5 />,  
  },
]

const EnrichmentSection = ({refresh}:any) => {
  const [paramsTasteSuggestion, setParamsTasteSuggestion] = useState({
    type: TypeSuggestion.TASTE,
    refresh: refresh,
  });

  useEffect(() => {
    setParamsTasteSuggestion({
      type: TypeSuggestion.TASTE,
      refresh: refresh,
    })
  }, [refresh]);

  const [tasteSuggestion, loading] = useSuggestionByType(paramsTasteSuggestion);

  const hasData = tasteSuggestion?.items?.length > 0;
  
  return (
    <section className={
      `rounded-none mb-2.5 py-[30px] bg-white shadow-sm mx-auto min-w-0 gap-2.5`
    }>
      <div className="px-4 mb-5">
        <p className="text-[#777777] text-[12px] font-medium">
          {_t("main.tasteSuggestion1")}
        </p>
        <h2 className="text-[17px] font-bold text-[#111111] flex items-baseline">
        <div className="mr-1">
            <IconSectionEnrichment />
        </div> {_t("main.tasteSuggestion2")}
        </h2>
      </div>
      <div className="flex overflow-x-scroll no-scrollbar px-4 gap-2">
        {(loading && !hasData) && <SectionSkeleton />}
        {(tasteSuggestion?.items?.sort((a:any, b:any) => a?.id - b?.id) || []).map((data: any, index: number) => (
          <EnrichmentCard
            key={index}
            {...data}
            title={_t(ImageTaste[index].title)}
            description={_t(ImageTaste[index].description)}
            thumbnail={ImageTaste[index].thumbnail}
            background={`#${data.background_color}`}
          />
        ))}
      </div>
      <MainNodata
        loading={loading}
        data={tasteSuggestion}
        text={_t("main.no_data")}
      />
    </section>
  );
};

export default memo(EnrichmentSection);
